<template>
    <div class="t-box">
        <div v-for="(item,index) in titleArr" :class="{'end-route':index==titleArr.length-1}" :key="index">{{ item+(index==titleArr.length-1?'':'>') }}</div>
    </div>
</template>

<script>
    export default {
        props:['routeArr'],
        data(){
            return{
                titleArr:[]
            }
        },
        methods:{
            /**获取路由标题名称 */
            queryRouteTitle(){
                return this.$route.matched.map(item=>item.meta.title);
            }
        },
        mounted(){
            if(!this.routeArr){
                this.titleArr=this.queryRouteTitle();
            }else{
                this.titleArr=this.routeArr;
            }
        }
    }
</script>

<style lang="less" scoped>
.t-box{
    font-size: 16px;
    display: flex;
    align-items: center;
    color: #0D0825;
}
.end-route{
    font-size: 1.8rem;
    font-weight: 550;
}
</style>